import type { FC } from "react";

export const ImagioOpticalMaterialDataLabel: FC = () => {
  return (
    <span>
      Imagio<sup style={{ fontSize: "0.8em", verticalAlign: "top" }}>®</sup>{" "}
      Optical Material Data
    </span>
  );
};
